import React from "react";

import OfferingStatusBadge from "./OfferingStatusBadge";
import OfferingTypeBadge from "./OfferingTypeBadge";

const OfferingDetails = ({
  offering,
  loading = false,
  onEdit,
}) => {
  if (loading) {
    return (
      <div className="offering-details-state">
        Loading offering...
      </div>
    );
  }

  if (!offering) {
    return (
      <div className="offering-details-state">
        Offering not found.
      </div>
    );
  }

  return (
    <section className="offering-details">
      <div className="offering-details-header">
        <div>
          <h2>{offering.name}</h2>

          <p className="offering-slug">
            /{offering.slug}
          </p>
        </div>

        {onEdit && (
          <button
            type="button"
            onClick={() => onEdit(offering)}
          >
            Edit Offering
          </button>
        )}
      </div>

      <div className="offering-details-badges">
        <OfferingTypeBadge
          type={offering.type}
        />

        <OfferingStatusBadge
          isActive={offering.is_active}
        />
      </div>

      <div className="offering-details-grid">
        <div className="detail-item">
          <span>Category</span>
          <strong>
            {offering.category_name || "-"}
          </strong>
        </div>

        <div className="detail-item">
          <span>Display Order</span>
          <strong>
            {offering.display_order ?? 0}
          </strong>
        </div>

        <div className="detail-item">
          <span>Created</span>
          <strong>
            {offering.created_at
              ? new Date(
                  offering.created_at
                ).toLocaleString()
              : "-"}
          </strong>
        </div>

        <div className="detail-item">
          <span>Updated</span>
          <strong>
            {offering.updated_at
              ? new Date(
                  offering.updated_at
                ).toLocaleString()
              : "-"}
          </strong>
        </div>
      </div>

      {offering.short_description && (
        <div className="offering-description-section">
          <h3>Short Description</h3>

          <p>
            {offering.short_description}
          </p>
        </div>
      )}

      {offering.description && (
        <div className="offering-description-section">
          <h3>Description</h3>

          <p className="description-text">
            {offering.description}
          </p>
        </div>
      )}
    </section>
  );
};

export default OfferingDetails;